import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  selectModels,
} from '../../actions/advisor';
import {
  Modal,
  ModalBody,
} from 'reactstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import s from './SelectModelForm.css';

library.add(faCircleNotch);

class SelectModelForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  closeModal(){
    this.setState({
      showModal: false,
    });
  }

  selectModels = (event) => {
    const {
      client,
    } = this.props;
    event.preventDefault();
    this.setState({
      showModal: true,
    });
    this.props.selectModels(client).then(() => {
      this.setState({
        showModal: false,
      });
    });
  }

  checkPersonlizeOK(client) {
    let hasPort = false;
    let hasGoal = false;
    let hasInfo = false;
    let hasLA = false;
    if (client.holdings && client.holdings.length > 0) {
      hasPort = true;
    }
    if (client.laScore > 0) {
      hasLA = true;
    }
    const sortedResults = client.results.filter((result) => result.name === 'loss-aversion');
    if (sortedResults.length > 0) {
      hasLA = true;
    }
    if (client.retireMonthlyIncome > 0) {
      hasGoal = true;
    }
    if (client.birthYear && client.retireAge ) {
      hasInfo = true;
    }
    return (hasPort && hasGoal && hasInfo && hasLA);
  }

  render() {
    const {
      showModal,
    } = this.state;
    const {
      client,
    } = this.props;

    const personalizeOK = this.checkPersonlizeOK(client);

    return (
      <div>
      <div className={s.content}>
          <div className={'row'}>
            <div className='col-md-12'>
              {personalizeOK && client.isDirty &&
                <button
                  onClick={this.selectModels}
                  className={s.saveButton}
                >PERSONALIZE PORTFOLIO</button>
              }
              {personalizeOK && !client.isDirty &&
                <div className={s.message}>PORTFOLIO PERSONALIZATION<br />UP TO DATE</div>
              }
              {!personalizeOK &&
                <div className={s.message}>GOALS OR PORTFOLIO<br />INCOMPLETE</div>
              }
            </div>
          </div>
      </div>
      <Modal isOpen={showModal} toggle={() => this.closeModal()} className={'modal-info'}>
        <ModalBody style={{textAlign:'center'}}>
        <h3>The universe spins<br />
          Eyes swirl around a cup of tea<br />
          The spoon is patient<br />
          <FontAwesomeIcon icon="circle-notch" size="2x" style={{ marginTop:'20px', color: '#05A9B1' }} spin />
        </h3>
        </ModalBody>
      </Modal>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  selectModels,
})(SelectModelForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/SelectModelForm.js